module.exports = "<div class=\"piechart\">\n  <canvas #chart id=\"pieCanvas{{ review.Id }}\"></canvas>\n  <span>64 total</span>\n</div>\n"